import { DetailValue } from 'components/common'
import { getDetailUrl } from 'models/CardTypeBenefit/api'


const CardTypeBenefitValue = ({ detail, asLink, isBack }) => {
  return (
    <DetailValue
      url={asLink && getDetailUrl(detail)}
      isBack={isBack}
      className="flex"
      render={() => (
        <>
          {detail?.tenant.name || '-'}
        </>
      )}
    />
  );
};


export default CardTypeBenefitValue
